// src/api/community.js
import { API_BASE } from "../config";

function toQuery(params) {
    const qs = new URLSearchParams();
    if (params.q) qs.set("q", params.q);
    // backend expects multiple category params: ?category=EVENT&category=DJ
    if (Array.isArray(params.category) && params.category.length) {
        params.category.forEach(c => qs.append("category", String(c).toUpperCase()));
    }
    qs.set("sort", params.sort || "newest");
    qs.set("page", String(params.page ?? 0));
    qs.set("size", String(params.size ?? 12));
    return qs.toString();
}

async function handle(res) {
    if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(`HTTP ${res.status}: ${text || res.statusText}`);
    }
    return res.json();
}

export async function fetchArticles({ q = "", category = [], sort = "newest", page = 0, size = 12 } = {}) {
    const qs = toQuery({ q, category, sort, page, size });
    const res = await fetch(`${API_BASE}/api/community/articles?${qs}`, {
        // credentials: "include", // enable if your API uses cookies
    });
    return handle(res);
}

export async function fetchArticle(slug) {
    const res = await fetch(`${API_BASE}/api/community/articles/${encodeURIComponent(slug)}`);
    return handle(res);
}

export function bumpView(id) {
    // fire-and-forget; ignore failures
    return fetch(`${API_BASE}/api/community/articles/${id}/view`, {
        method: "POST",
        // credentials: "include", // only if needed
    }).catch(() => { });
}
